import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiCheckbox from '@material-ui/core/Checkbox';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/styles';

const withCheckBoxColor = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.light,
    '&$disabled': {
      color: theme.palette.text.primary,
    },
  },
  disabled: {},
}));

const Checkbox = ({ name, value, onChange, label, disabled }) => {
  const classes = withCheckBoxColor();
  return (
    <FormGroup className={styles.formGroup}>
      <FormControlLabel
        className={styles.formControlLabel}
        control={
          <MuiCheckbox
            disabled={disabled}
            checked={value || false}
            color="default"
            inputProps={{ name }}
            onChange={onChange}
            disableRipple
            classes={{ root: classes.root, disabled: classes.disabled }}
          />
        }
        label={<div className={styles.label}>{label}</div>}
      ></FormControlLabel>
    </FormGroup>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default Checkbox;
